import * as React from "react";
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import DrugInteractionsLegend from '../medicines/MedicineCommon/drugInteractionsLegend';
import InteractionsResultsDrugToDrug from './interactionsResultsDrugToDrug';
import InteractionsResultsDrugToDisease from './interactionsResultsDrugToDisease';
import InteractionsResultsDrugToOthers from './interactionsResultsDrugToOthers';
import { InteractionsResultModel } from '../../models/interactions/interactionsResultModel';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from '@material-ui/core/Paper';
import WarningIcon from '@material-ui/icons/Warning';
import getInteractionSeverity from '../medicines/MedicineCommon/interactionsSeverityFunctions';
import { InteractionType } from '../../common/enums';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { flexbox } from "@material-ui/system";

interface IProps {
  history: any,
  interactionsResult: InteractionsResultModel,
  lang: string
}

interface IState {
  isLoading: boolean;
  error: any;
  activeIndex: any;
}

class InteractionsResultsComponent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      activeIndex: null
    };
  }

  componentDidMount() {

  }

  handleInteractionTabClick = (e, value) => {
    e.preventDefault();
    this.props.history.push(`/interactions?tabName=${value}`);
  }

  handleTabMenuchange = panel => (event, expanded) => {
    this.setState({ activeIndex: expanded ? panel : false, });
  }

  public render() {
    const { isLoading, error, activeIndex } = this.state;
    const { interactionsResult } = this.props;

    let tabNameUrl = HelperFunctions.getURLParameter('tabName');
    let tabName = tabNameUrl ? tabNameUrl + '' : 'DrugToDrug';

    let drugMajorInteractionCount = 0;
    let drugModerateInteractionCount = 0;
    let drugMinorInteractionCount = 0;
    let drugUnknownInteractionCount = 0;

    interactionsResult.drugToDrugInteractionsResults
      .map(r => r.drugToDrugInteractions
        .map(i => {
          switch (i.interactionTypeId) {
            case InteractionType.Major: drugMajorInteractionCount++;
              break;
            case InteractionType.Moderate: drugModerateInteractionCount++;
              break;
            case InteractionType.Minor: drugMinorInteractionCount++;
              break;
            case InteractionType.Unknown: drugUnknownInteractionCount++;
              break;
          }
        }));

    let diseaseMajorInteractionCount = 0;
    let diseaseModerateInteractionCount = 0;
    let diseaseMinorInteractionCount = 0;
    let diseaseUnknownInteractionCount = 0;

    interactionsResult.drugToDiseaseInteractionsResults
      .map(r => r.drugToDiseaseInteractions
        .map(i => {
          switch (i.interactionTypeId) {
            case InteractionType.Major: diseaseMajorInteractionCount++;
              break;
            case InteractionType.Moderate: diseaseModerateInteractionCount++;
              break;
            case InteractionType.Minor: diseaseMinorInteractionCount++;
              break;
            case InteractionType.Unknown: diseaseUnknownInteractionCount++;
              break;
          }
        }));

    return (
      <>
        <h3>{Translate('Interactions with')}:</h3>

        <Paper style={{ padding: "5px 10px", marginBottom: "10px" }}>
          <h3>{Translate('Medicines')}</h3>
          <div className="interactions-result-badge" style={{ margin: "15px 0" }}>
            <div className="badge-container">
              <div className="badge major">
                {drugMajorInteractionCount}
              </div>
              <div style={{ fontWeight: 600, color: "#d32f2f", marginRight: "10px" }}>
                {Translate('Major')}
              </div>
            </div>
            <div className="badge-container">
              <div className="badge moderate">
                {drugModerateInteractionCount}
              </div>
              <div style={{ fontWeight: 600, color: "#f57c00", marginRight: "10px" }}>
                {Translate('Moderate')}
              </div>
            </div>
            <div className="badge-container">
              <div className="badge minor">
                {drugMinorInteractionCount}
              </div>
              <div style={{ fontWeight: 600, color: "#fbc02d", marginRight: "10px" }}>
                {Translate('Minor')}
              </div>
            </div>
            <div className="badge-container">
              <div className="badge unknown">
                {drugUnknownInteractionCount}
              </div>
              <div style={{ fontWeight: 600, color: "#b3b3b3", marginRight: "10px" }}>
                {Translate('Unknown')}
              </div>
            </div>
          </div>
          {interactionsResult.drugToDrugInteractionsResults.length > 0 ?
            <InteractionsResultsDrugToDrug
              history={this.props.history}
              drugToDrugInteractionsResults={interactionsResult.drugToDrugInteractionsResults}
            /> : <div className='pt-10'>{Translate('There is no drug interactions.')}</div>}
        </Paper>

        <Paper style={{ padding: "5px 10px", marginBottom: "10px" }}>
          <h3>{Translate('Diseases')}</h3>
          <div className="interactions-result-badge" style={{ margin: "15px 0" }}>
            <div className="badge-container">
              <div className="badge major">
                {diseaseMajorInteractionCount}
              </div>
              <div style={{ fontWeight: 600, color: "#d32f2f", marginRight: "10px" }}>
                {Translate('Major')}
              </div>
            </div>
            <div className="badge-container">
              <div className="badge moderate">
                {diseaseModerateInteractionCount}
              </div>
              <div style={{ fontWeight: 600, color: "#f57c00", marginRight: "10px" }}>
                {Translate('Moderate')}
              </div>
            </div>
            <div className="badge-container">
              <div className="badge minor">
                {diseaseMinorInteractionCount}
              </div>
              <div style={{ fontWeight: 600, color: "#fbc02d", marginRight: "10px" }}>
                {Translate('Minor')}
              </div>
            </div>
            <div className="badge-container">
              <div className="badge unknown">
                {diseaseUnknownInteractionCount}
              </div>
              <div style={{ fontWeight: 600, color: "#b3b3b3", marginRight: "10px" }}>
                {Translate('Unknown')}
              </div>
            </div>
          </div>
          {interactionsResult.drugToDiseaseInteractionsResults.length > 0 ?
            <InteractionsResultsDrugToDisease
              history={this.props.history}
              drugToDiseaseInteractionsResult={interactionsResult.drugToDiseaseInteractionsResults}
            /> : <div className='pt-10'>{Translate('There is no diseases interactions.')}</div >}
        </Paper>

        <Paper style={{ padding: "5px 10px", marginBottom: "10px" }}>
          <h3 style={{ margin: "10px 0" }}>{Translate('Other parameters')}</h3>
          {interactionsResult.drugToOtherParametersResults.some(r => r.pregnancy == true || r.profession == true) ?
            <InteractionsResultsDrugToOthers
              history={this.props.history}
              drugToOtherParametersResults={interactionsResult.drugToOtherParametersResults}
            /> : <div className='pt-10'>{Translate('There is no other interactions.')}</div >}
        </Paper>

        <DrugInteractionsLegend />
      </>
    )
  }
}

export default InteractionsResultsComponent;